import * as React from "react";

import { endOfDay, format, startOfDay } from "date-fns";
import { CalendarIcon } from "lucide-react";
import type { DateRange } from "react-day-picker";
import { ru } from "date-fns/locale";

import { cn } from "../lib/utils";
import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export const adjustDateRange = (date: DateRange | undefined) => {
  if (!date?.from) return undefined;

  if (date.from && date.to && date.from.getTime() === date.to.getTime()) {
    return {
      from: startOfDay(date.from),
      to: endOfDay(date.from),
    };
  }

  return date;
};

export function DatePickerWithRange({
  className,
  date,
  setDate,
  children,
}: React.HTMLAttributes<HTMLDivElement> & {
  date?: DateRange;
  setDate: React.Dispatch<React.SetStateAction<DateRange | undefined>>;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) {
  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          {children ?? (
            <Button
              id="date"
              variant={"outline"}
              className={cn(
                "h-10 justify-start text-left font-normal text-textColor md:w-[300px]",
              )}
            >
              <CalendarIcon />
              {date?.from ? (
                date.to ? (
                  <>
                    {format(date.from, "LLL dd, y", { locale: ru })} -{" "}
                    {format(date.to, "LLL dd, y", { locale: ru })}
                  </>
                ) : (
                  format(date.from, "LLL dd, y", { locale: ru })
                )
              ) : (
                <span>Выберите дату</span>
              )}
            </Button>
          )}
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="center">
          <Calendar
            initialFocus
            locale={ru}
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={(newDate) => setDate(adjustDateRange(newDate))}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
